import { getWelcomeTemplates, UserKeys } from '../../../../api/users-api';
import { useQuery } from '@tanstack/react-query';
import WelcomeTemplatesGrid from './welcome-templates-grid';
import { useUserSettings } from '../../../../utils/use-user-settings';
import { Messages } from '../../../../utils/message-constants';
import { useRouteMatch } from '../../../../shared/useRouteMatch';
import { pagesConfig } from '../../../../shared/pages-config';
import { Outlet } from 'react-router-dom';

import Stack from '@mui/material/Stack';
import SharedTabHeader from '../../../../shared/shared-tab-header';

export default function WelcomeTemplatesPage() {
  const { administrationRoles, changeLogRoles } = useUserSettings();

  const {
    data,
    isLoading: isLoadingEmailTemplates,
    isFetching: isFetchingEmailTemplates,
  } = useQuery({
    queryKey: [UserKeys.EmailTemplates],
    queryFn: () => getWelcomeTemplates(),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('welcome templates'),
    },
  });

  const isFormPage = useRouteMatch([
    `${pagesConfig.settings.link}/${pagesConfig.welcomeTemplates.link}/${pagesConfig.welcomeTemplatesFormPage.link}`,
    `${pagesConfig.settings.link}/${pagesConfig.welcomeTemplates.link}/${pagesConfig.editWelcomeTemplatesFormPage.link}`,
  ]);

  if (isFormPage) return <Outlet />;

  return (
    <Stack gap={2}>
      <SharedTabHeader title="Welcome Templates" />
      <WelcomeTemplatesGrid
        templates={data?.results || []}
        isLoading={isLoadingEmailTemplates}
        isFetching={isFetchingEmailTemplates}
        changeLogRoles={changeLogRoles}
        administrationRoles={administrationRoles}
      />
    </Stack>
  );
}
